import {
  ISortedScaleSet,
  SortedScaleSetMap,
} from '@epicuro-next/models/products';

export function getScaleSetMap(
  sortedScaleSets: ISortedScaleSet[],
  setKey: 'size' | 'width' = 'size',
): SortedScaleSetMap {
  const index = setKey === 'size' ? 0 : 1;
  const sortedValues = sortedScaleSets[index]?.sortedValues;
  if (!sortedValues) {
    return {};
  }

  const map: SortedScaleSetMap = {};
  for (const sortedValue of sortedValues) {
    const masterValue = sortedValue.values.find(
      ({ key }) => key === sortedValue.defaultValue,
    )?.value;

    if (masterValue != null) {
      map[masterValue as string] = sortedValue;
    }
  }

  return map;
}
